module.exports = __webpack_public_path__ + "img/1970East-009_WEB-min.d36ecbfe.jpg";